<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pl-2">settings</v-icon>
            Template Settings
          </span>
          <v-btn absolute left depressed flat fab small @click="closeModal()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <small>* indicates required field</small>
          <v-form ref="settings_template" data-vv-scope="settings_template" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 mt-3>
                <v-text-field
                  v-model="form.title"
                  v-validate="'required'"
                  data-vv-name="settings_template.title"
                  :error-messages="errors.collect('settings_template.title')"
                  label="Title*"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 mt-3>
                <v-text-field
                  v-model="form.subtitle"
                  v-validate="'required'"
                  data-vv-name="settings_template.subtitle"
                  :error-messages="errors.collect('settings_template.subtitle')"
                  label="Subtitle*"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 mt-3>
                <p class="subheading grey--text">Description</p>
                <vue-editor
                  :id="'description'"
                  v-model="form.description"
                  :editor-toolbar="editorToolbar"
                ></vue-editor>
              </v-flex>
              <!-- <v-flex xs12 mt-3>
                <p class="subheading grey--text">Header page text</p>
                <vue-editor
                  :id="'header'"
                  v-model="form.header_text"
                  :editor-toolbar="editorToolbar"
                ></vue-editor>
              </v-flex>
              <v-flex xs12 mt-3>
                <p class="subheading grey--text">Footer page text</p>
                <vue-editor
                  :id="'footer'"
                  v-model="form.footer_text"
                  :editor-toolbar="editorToolbar"
                ></vue-editor>
              </v-flex> -->
              <v-flex xs12 mt-3>
                <v-toolbar dense>
                  <v-toolbar-title class="subheading grey--text">Remarks</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-overflow-btn
                      v-model="form.remarks_position"
                      :items="remarks_position"
                      editable
                      label="Position on page"
                      hide-details
                      style="width:200px"
                      class="pa-0"
                      overflow
                    ></v-overflow-btn>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        dark
                        small
                        color="red"
                        @click="form.remarks = null; form.remarks_position = null"
                        v-on="on"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Clear remarks</span>
                  </v-tooltip>
                </v-toolbar>
                <vue-editor
                  :id="'remarks'"
                  v-model="form.remarks"
                  :editor-toolbar="editorToolbar"
                ></vue-editor>
              </v-flex>
              <v-flex xs12 mt-4>
                <v-layout v-if="form.image_name" row wrap>
                  <v-flex xs4>
                    <v-img
                      :src="getFilePath(form.image_name)"
                      class="preview-img"
                      height="120px"
                      contain
                    ></v-img>
                  </v-flex>
                  <v-flex xs8>
                    <span style="margin: auto 10px;">{{ form.image_name }}</span>
                    <v-btn icon class="ml-0" @click="clearImage(); $forceUpdate(); ">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout v-else>
                  <upload-btn
                    id="imageFile"
                    ref="imageFile"
                    @file-update="updateImageFile"
                    :title="imageBtnTitle"
                    class="mx-0 px-0"
                  >
                    <template slot="icon">
                      <v-icon>add</v-icon>
                    </template>
                  </upload-btn>
                  <v-btn v-if="imageFile" icon class="ml-0" @click="clearImage()">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
            </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions class="mt-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn
            color="primary"
            flat
            @click="save()"
            :disabled="loading > 0"
            :loading="loading > 0"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import UploadButton from 'vuetify-upload-button'
import { VueEditor } from 'vue2-editor'
export default {
  name: 'TemplateSettingsModal',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'upload-btn': UploadButton,
    VueEditor
  },
  props: ['templateSettingsDialog', 'global'],
  data () {
    return {
      dialog: this.templateSettingsDialog,
      loading: 0,
      form: {
        title: (this.global && this.global.title) ? this.global.title : 'Monthly SEO Report',
        subtitle: (this.global && this.global.subtitle) ? this.global.subtitle : '',
        description: (this.global && this.global.description) ? this.global.description : '',
        header_text: (this.global && this.global.header_text) ? this.global.header_text : '',
        footer_text: (this.global && this.global.footer_text) ? this.global.footer_text : '',
        remarks: (this.global && this.global.remarks) ? this.global.remarks : '',
        remarks_position: (this.global && this.global.remarks_position) ? this.global.remarks_position : null,
        image_name: (this.global && this.global.image_name) ? this.global.image_name : null
      },
      content: '',
      imageFile: null,
      imageBtnTitleDefault: 'Add Company Logo',
      imageBtnTitle: 'Add Company Logo',
      remarks_position: [
        { text: 'Second page', value: 2 },
        { text: 'Last page', value: -1 }
      ],
      editorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ]
      ],
      dictionary: {
        en: {
          custom: {
            'settings_template.title': {
              required: 'Please enter title'
            },
            'settings_template.subtitle': {
              required: 'Please enter subtitle'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  computed: {
  },
  watch: {
    templateSettingsDialog: {
      handler () {
        console.log(this.templateSettingsDialog)
        this.dialog = this.templateSettingsDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('templateSettingsDialog', this.dialog)
      }
    }
  },
  methods: {
    updateImageFile (file) {
      if (file) {
        if (file.size > 5242880) {
          this.$toasted.show('Allowed image size: 5MB', { type: 'warning' })
          this.$refs.imageFile.clear()
        } else {
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            this.imageFile = new File([file], file.name, { type: file.type })
            this.imageBtnTitle = (file.name.length > 15 ? file.name.substring(0, 15) + '...' : file.name)
            this.$refs.imageFile.clear()
          } else {
            this.$refs.imageFile.clear()
            this.$toasted.show('Allowed formats: png, jpg, jpeg', { type: 'warning' })
          }
        }
      }
    },
    save () {
      this.$validator.validateAll('settings_template').then(res => {
        if (res) {
          this.loading++
          let params = {
            title: this.form.title,
            subtitle: this.form.subtitle,
            description: this.form.description,
            header_text: this.form.header_text,
            footer_text: this.form.header_text,
            remarks: this.form.remarks,
            remarks_position: this.form.remarks_position || -1,
            image_name: this.form.image_name
          }
          let formData = new FormData()
          Object.keys(params).map((objectKey, index) => {
            formData.append(objectKey, params[objectKey])
          })
          if (this.imageFile) {
            formData.append('image_file', this.imageFile)
          }
          this.$store.dispatch('UPDATE_GLOBAL_TEMPLATE', { globalId: this.global.id, params: formData }).then(res => {
            this.loading--
            this.closeModal()
            this.$eventEmitter.$emit('updateGlobal')
          }, err => {
            console.log('UPDATE_GLOBAL_TEMPLATE ERROR', err)
            this.loading = false
            let errorText = this.$services.getApiError(err)
            if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    getFilePath (fileName) {
      if (window.location.origin.includes('localhost')) {
        return 'https://ky-stage.wecandevelopit.com' + this.$store.state.global.template_file_path + fileName
      }
      return window.location.origin + this.$store.state.global.template_file_path + fileName
    },
    clearImage () {
      if (this.imageFile) {
        this.$refs.imageFile.clear()
        this.imageFile = null
        this.imageBtnTitle = this.imageBtnTitleDefault
      }
      this.form.image_name = null
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
#header .ql-editor,
#footer .ql-editor,
#description .ql-editor {
  min-height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/globals/TemplateSettingsModal.vue